import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';
import numeral from 'numeral';

const View = (props) => {
    return (
        <div className="p-2">
            <div>
                Harga pengiriman
            </div>
            <div>
                <b>Rp. {numeral(props.price).format("0,0")}</b>
            </div>
        </div>
    )
}

export default View